module.exports = __webpack_public_path__ + "static/media/webdesign-services-img7.9dc28e93.jpg";